/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';

// dispatch function for search
export const dispatchSearchData = (data) => {
  return {
    type: actionTypes.SEARCH_SCREEN_TAB_CMS_MISMATCH,
    searchScreen: data,
  };
};
// plan Type dispatch
export const dispatchPlanType = (data) => ({
  type: actionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});
// To get plantype data
export const getCheckBoxValue = () => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(dispatchPlanType([]));
    });
};
// checked value Dispatch Function
export const dispatchCheckedValueCMS = (data) => ({
  type: actionTypes.GET_CHECKED_VALUE,
  payload: data,
});

// rebate programe dispatch function
export const dispatchRebatePrograme = (data) => ({
  type: actionTypes.GET_REBATE_PROGRAM,
  payload: data,
});

//  get rebate programe funnction
export const getRebateProgrameList = (value) => {
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      return response.data;
    })
    .catch(() => {
      return [];
    });
};
// dispatch quarter value function
export const dispatchQuarterValue = (data) => ({
  type: actionTypes.GET_QUARTER_VALUE,
  payload: data,
});
//  get quarter value data
export const getQuarterValue = (value) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_QTR_FOR_CMS_MISMATCH)
    .then((response) => {
      return dispatch(dispatchQuarterValue(response.data));
    })
    .catch((response) => {
      dispatch(dispatchQuarterValue([]));
    });
};
//  error msg dispatch function
export const dispatchErrorMsg = (data) => ({
  type: actionTypes.GET_ERROR_MSG_CMS_MISMATCH,
  payload: data,
});

// dispatch function for cms mismatch details
export const dispatchCmsMismatchDetail = (data) => ({
  type: actionTypes.GET_CMS_MISMATCH_DETAIL,
  payload: data,
});

// get function for cms mismatch  details
export const getCmsMismatchDetails = (val) => (dispatch) => {
  return axios
    .post(serviceEndPoint.GET_CMS_MISMATCH_DETAIL, val)
    .then((response) => {
      return dispatch(dispatchCmsMismatchDetail(response.data));
    })
    .catch((response) => {
      dispatch(dispatchCmsMismatchDetail([]));
    });
};

// dispatch function for tab data for CMS details screen
export const dispatchCmsMismatchDetailTabData = (data) => ({
  type: actionTypes.GET_CMS_MISMATCH_DETAIL_TAB_DATA,
  detailScreen: data,
});

// clear redux
export const clearReduxForCmsMissMatchSearchScrren = () => (dispatch) => {
  dispatch(dispatchSearchData({}));
  dispatch(dispatchErrorMsg([]));
  dispatch(dispatchPlanType([]));
  dispatch(dispatchQuarterValue([]));
  dispatch(dispatchCheckedValueCMS({}));
};
export const clearReduxForCmsMissMatchDetailScrren = () => (dispatch) => {
  dispatch(dispatchCmsMismatchDetail([]));
  dispatch(dispatchCmsMismatchDetailTabData({}));
};
